export enum LogInAction {
    UPDATE_ACTIVE_VIEW = "UPDATE_ACTIVE_VIEW",
    UPDATE_NUMBER = "UPDATE_NUMBER",
    VALIDATE_NUMBER = "VALIDATE_NUMBER",
    UPDATE_OTP = "UPDATE_OTP",
    VALIDATE_OTP = "VALIDATE_OTP",
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_SEND_OTP_RES = "UPDATE_SEND_OTP_RES",
}